import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { Table } from 'primeng/table';
import { PagosService, ReportesService, OptionsService } from '../../services/service.index';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import swal2 from 'sweetalert2';
import { AltaSolicitudesService } from '../../services/altasolicitudes/altasolicitudes.service';
// [13/08/2026] Se retiró Bugsnag: el dashboard no se revisaba hace ~1 año. Los errores se siguen logueando en console.log.
// Servicio de polling para monitoreo de progreso de pagos
import { PaymentPollingService } from '../../services/pagos/payment-polling.service';

declare var $;

@Component({
  selector: 'app-aproveedor',
  templateUrl: './aproveedor.component.html',
  styleUrls: ['../alta solicitudes/altasolicitudes.component.css']
})
export class AproveedorComponent implements OnInit, OnDestroy {
  @ViewChild('dt', { static: false }) tabla: Table;
  filasPorPagina: number = 100;
  opcionesTamanoPagina: number[] = [20, 50, 100];
  paginaActualSeleccionada: boolean = false;
  paginaActualIndeterminada: boolean = false;
  // INICIO CAMBIO: checkbox "Todas" externo
  todasSeleccionadas: boolean = false;
  // FIN CAMBIO
  factoraje_type = '';

  constructor(private _formBuilder: FormBuilder,
              public _optionsservice: OptionsService,
              public router: Router,
              private route: ActivatedRoute,
              public _reportesservice: ReportesService,
              public _pagosservice: PagosService,
              private _solicitudesservice: AltaSolicitudesService,
              // Servicio de polling para registrar trabajos de pago y monitorear progreso
              private paymentPollingService: PaymentPollingService) {}

  cols: any[];
  a = new Date();
  fecha: string;
  proveedores: any[];
  proveedoreso: any[] = [];
  proveedoresw: any[];
  proveedoresow: any[] = [];
  correo: string;
  facturas: any[] = [];
  selectedFac: any[];
  idp: string;
  idcontribuyente: string;
  idcontfinan: string;
  pago: any[] = [];
  supplierpaymentid = '';
  totalFac = 0;
  totalFacs = '0';
  totalFacsFormateado = '0';
  sinrecurso = 'false';
  valorcsrecurso = 'SIN_RECURSO';
  currency = [];
  paymentTypes = [];
  nomname = '';
  selectedBank: string = '';
  banks: any[] = [];
  hayBancos = false;
  npago = '';
  // Indica si el procesamiento de pagos es asíncrono (Sidekiq)
  asyncPaymentProcessing: boolean = false;

  private _guardarTimer: any = null;
  ngOnInit() {
    // Inicializar servicio de polling: lee sessionStorage y reconecta polling para pagos pendientes
    this.paymentPollingService.initialize();

    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
 });
    swal2.showLoading();
    this.sinrecurso = 'false';
   // this.getAcceso('/pagos/aproveedor');

    this.a = new Date();

    (document.getElementById('npago') as HTMLInputElement).value = '';

    (document.getElementById('voucher') as HTMLInputElement).value = '';

    (document.getElementById('notas') as HTMLInputElement).value = '';

    this.totalFacs = '0';

    this.totalFacsFormateado = '0';

    this.proveedoreso = [];

    this.proveedores = [];

    this.selectedFac = [];

    this.facturas = [];

    this.correo = '';

    this.idp = '';

    this.totalFac = 0;

    this._pagosservice.getProveedores().subscribe( resp => {this.proveedores = resp;
                                                            
                                                            swal2.close();
    } );

    this._solicitudesservice.getGeneralParam('NOMBRE_FINANCIERA').subscribe(resp => {this.nomname = resp['value']});
    this._solicitudesservice.getGeneralParam('FACTORAJE_TYPE').subscribe(resp => {
      this.factoraje_type = resp['value'];
      if(this.factoraje_type == 'SIN_RECURSO' || this.factoraje_type == 'CON_RECURSO'){
        this.seleccioncsrecurso(this.factoraje_type);
      }else{
        this.factoraje_type = 'SIN_RECURSO';
        this.seleccioncsrecurso(this.factoraje_type);
      }
    });

    this._solicitudesservice.getPaymentCurrency().subscribe( resp => this.currency = resp );
    this._solicitudesservice.getPaymentTypes().subscribe(resp => this.paymentTypes = resp);
    this._pagosservice.getAcountigAcountBanks().subscribe(resp => {
      this.banks = resp;
      this.hayBancos = resp && resp.length > 0;
    });
    // Consultar si el procesamiento de pagos es asíncrono (con delay de 2s para evitar colisión de respuestas)
    setTimeout(() => {
      this._solicitudesservice.getGeneralParam('ASYNC_PAYMENT_PROCESSING').subscribe(resp => {
        this.asyncPaymentProcessing = resp['value'] === 'SI';
      });
    }, 2000);
    this.a.setMinutes( this.a.getMinutes() + this.a.getTimezoneOffset() );
    let montha = '' + (this.a.getMonth() + 1);
    let daya = '' + this.a.getDate();
    const yeara = this.a.getFullYear();

    if (montha.length < 2) {
        montha = '0' + montha;
    }
    if (daya.length < 2) {
        daya = '0' + daya;
    }

    this.fecha = [yeara, montha, daya].join('-');

    this.cols = [
      { field: 'folio_reporte', header: 'Folio Reporte' },
      { field: 'folio_factura', header: 'Folio Factura' },
      { field: 'uuid', header: 'UUID' },
      { field: 'importe_neto', header: 'Importe Neto' },
      { field: 'porcentaje_operado', header: 'Porcentaje Operado' },
      { field: 'emisor', header: 'Emisor' },
      { field: 'receptor', header: 'Receptor' },
      { field: 'moneda', header: 'Moneda' },
      { field: 'fecha_operacion', header: 'Fecha de operación' },
      { field: 'fecha_vencimiento', header: 'Fecha de vencimiento' },
      { field: 'fecha_emision', header: 'Fecha de emision' },
      { field: 'fecha_carga', header: 'Fecha de carga' },
      { field: 'estatus', header: 'Estatus' }
    ];


  }

  seleccioncsrecurso(value) {
    this.proveedoreso = [];
    this.proveedores = [];
    this.proveedoresow = [];
    this.proveedoresw = [];
    this.facturas = [];
    this.selectedFac = [];
    this.paginaActualSeleccionada = false;
    this.paginaActualIndeterminada = false;
    this.todasSeleccionadas = false;
    this.idp = '';
    this.npago = '';
    this.selectedBank = '';
    this.totalFacsFormateado = '0';
    (document.getElementById('correo') as HTMLInputElement).value = '';
    (document.getElementById('notas') as HTMLInputElement).value= '';
    (document.getElementById('voucher') as HTMLInputElement).value = '';
    this.valorcsrecurso = value;
    if ( value === 'SIN_RECURSO' ) {
      swal2.showLoading();
      this._pagosservice.getProveedores().subscribe( resp => {this.proveedores = resp;
        swal2.close();
} );
    } else if (value === 'CON_RECURSO') {
      swal2.showLoading();
      this._pagosservice.getpayment_with_recourse_companies().subscribe( resp => {this.proveedoresw = resp;
        swal2.close();
} );
    }
  }

  getcorreo() {
    this.facturas = [];
    this.selectedFac = [];
    this.paginaActualSeleccionada = false;
    this.paginaActualIndeterminada = false;
    this.todasSeleccionadas = false;
    this.totalFacsFormateado = '0';
    if (this.valorcsrecurso === 'SIN_RECURSO') {
      const proveedor: any = document.getElementById('proveedor');
      const valorproveedor = proveedor.options[proveedor.selectedIndex].value;
       for ( const prop in this.proveedores ) {
  
        if ( this.proveedores[prop].id_proveedor == valorproveedor ) {
          // VALIDA SI EL INTEREST_COMPANY ES TRUE O FALSE PARA SELECCIONAR A QUIEN SE LE ENVIA FACTURA DE INTERESES
          if (this.proveedores[prop].intereses_cadena){
            this.correo = this.proveedores[prop].interest_company_email;
          }else{
            this.correo = this.proveedores[prop].email_contribuyente;
          }
          this.idp = this.proveedores[prop].id_proveedor;
          this.idcontribuyente = this.proveedores[prop].id_contribuyente;
          this.idcontfinan = this.proveedores[prop].id_cont_finan;
        //  break;
  
        }
        
      } 
    } else if (this.valorcsrecurso === 'CON_RECURSO') {
      const proveedorw: any = document.getElementById('proveedorw');
    const valorproveedorw = proveedorw.options[proveedorw.selectedIndex].value;
    for ( const prop in this.proveedoresw ) {
  
      if ( this.proveedoresw[prop].id_cadena == valorproveedorw ) {
        this.idp = this.proveedoresw[prop].id_cadena;
        this.correo = this.proveedoresw[prop].email_contribuyente;
        this.idcontribuyente = this.proveedoresw[prop].id_contribuyente;
        this.idcontfinan = this.proveedoresw[prop].id_cont_finan;
      //  break;

      }
    } 
    }
    

  }

  getTotal() {

    this.totalFac = 0;
    let tp = 0;

    if ( this.selectedFac.length === 0 ) {

      this.totalFac = 0;

    } else {

      // tslint:disable-next-line: forin
      for ( const prop in this.selectedFac ) {

      //  this.totalFac = this.totalFac + parseFloat(this.selectedFac[prop].importe_neto);
        tp = tp + parseFloat(this.selectedFac[prop].importe_neto.replace(/,/g, ''));

      }

    }

   // this.totalFacs = this.totalFac.toFixed(2);
    this.totalFacs = tp.toFixed(2);
    this.totalFacsFormateado = tp.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  muestraFacturas() {
    if (this.valorcsrecurso === 'SIN_RECURSO') {
      if (this.idp === '') {
        swal2.fire('Debe seleccionar un proveedor', '', 'error');
        return;
      }
    const moneda: any = document.getElementById('moneda');
    const valormoneda = moneda.options[moneda.selectedIndex].value;
    swal2.fire({
      title: 'Cargando',
      allowOutsideClick: false
 });
    swal2.showLoading();
    this._pagosservice.getFacturasPagoProveedor( this.idp, valormoneda ).subscribe( resp => {
                                                                                              swal2.close();
                                                                                              this.facturas = resp;
                                                                                              if ( this.facturas.length === 0 ) {
                                                                                              swal2.fire(
                                                                                                'No se encontraron Datos',
                                                                                                '',
                                                                                                'error'
                                                                                              );
                                                                                            }
    } , (err) => {
      swal2.close();
      console.log(err);
      swal2.fire({
        title: 'Ocurrio un error',
        text: '',
        icon: 'error',
        showConfirmButton: true,
        showCancelButton: false,
        allowOutsideClick: false
      }). then ( res => {
        if ( res.value ) {
          location.reload();
        }
      } );
     }  );
    } else if (this.valorcsrecurso === 'CON_RECURSO') {
      if (this.idp === '') {
            swal2.fire('Debe seleccionar una empresa', '', 'error');
            return;
          }
      const moneda: any = document.getElementById('moneda');
      const valormoneda = moneda.options[moneda.selectedIndex].value;
      swal2.fire({
        title: 'Cargando',
        allowOutsideClick: false
   });
      swal2.showLoading();
      this._pagosservice.getFacturasPagoProveedorw( this.idp, valormoneda ).subscribe( resp => {
                                                                                                swal2.close();
                                                                                                this.facturas = resp;
                                                                                                if ( this.facturas.length === 0 ) {
                                                                                                swal2.fire(
                                                                                                  'No se encontraron Datos',
                                                                                                  '',
                                                                                                  'error'
                                                                                                );
                                                                                              }
      } , (err) => {
        swal2.close();
        console.log(err);
        swal2.fire({
          title: 'Ocurrio un error',
          text: '',
          icon: 'error',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {
          if ( res.value ) {
            location.reload();
          }
        } );
       }  );
    }

  }

  obtenerFilasPaginaActual(): any[] {
    if (!this.tabla) {
      return [];
    }
    const datos = this.tabla.filteredValue || this.tabla.value || [];
    const inicio = this.tabla.first || 0;
    const fin = inicio + (this.tabla.rows || this.filasPorPagina);
    return datos.slice(inicio, fin);
  }

  toggleSeleccionPagina(): void {
    const filasPagina = this.obtenerFilasPaginaActual();
    const todasSeleccionadas = filasPagina.length > 0 && filasPagina.every(fila => this.selectedFac.includes(fila));

    if (todasSeleccionadas) {
      this.selectedFac = this.selectedFac.filter(fila => !filasPagina.includes(fila));
    } else {
      const nuevas = filasPagina.filter(fila => !this.selectedFac.includes(fila));
      this.selectedFac = [...this.selectedFac, ...nuevas];
    }

    this.actualizarEstadoCheckboxPagina();
    this.getTotal();
  }

  actualizarEstadoCheckboxPagina(): void {
    const filasPagina = this.obtenerFilasPaginaActual();
    if (filasPagina.length === 0) {
      this.paginaActualSeleccionada = false;
      this.paginaActualIndeterminada = false;
      return;
    }
    const seleccionadas = filasPagina.filter(fila => this.selectedFac.includes(fila)).length;
    this.paginaActualSeleccionada = seleccionadas === filasPagina.length;
    this.paginaActualIndeterminada = seleccionadas > 0 && seleccionadas < filasPagina.length;
  }

  get excedeLimite(): boolean {
    return this.selectedFac.length > 50;
  }

  // INICIO CAMBIO: checkbox "Todas" externo
  toggleSeleccionTodas(): void {
    const datos = (this.tabla && this.tabla.filteredValue) ? this.tabla.filteredValue : this.facturas;
    if (this.todasSeleccionadas) {
      this.selectedFac = [];
    } else {
      this.selectedFac = [...datos];
    }
    this.todasSeleccionadas = !this.todasSeleccionadas;
    this.actualizarEstadoCheckboxPagina();
    this.getTotal();
  }

  actualizarEstadoCheckboxTodas(): void {
    const datos = (this.tabla && this.tabla.filteredValue) ? this.tabla.filteredValue : this.facturas;
    this.todasSeleccionadas = datos.length > 0 && this.selectedFac.length === datos.length;
  }
  // FIN CAMBIO

  guardar() {

    if (this.selectedFac.length === 0) {

      swal2.fire(
        'Debe seleccionar al menos una Factura',
        '',
        'error'
      );

    } else {

      const tpago: any = document.getElementById('tdpago');
      const moneda: any = document.getElementById('moneda');

      const valortpago = tpago.options[tpago.selectedIndex].value;
      const valormoneda = moneda.options[moneda.selectedIndex].value;
      let payment: any = { payment_date: (document.getElementById('fecha') as HTMLInputElement).value,
                   payment_number: (document.getElementById('npago') as HTMLInputElement).value,
                   payment_type: valortpago,
                   currency: valormoneda,
                   amount: this.totalFacs,
                   email_cfdi: (document.getElementById('correo') as HTMLInputElement).value,
                   notes: (document.getElementById('notas') as HTMLInputElement).value,
                   voucher: (document.getElementById('voucher') as HTMLInputElement).value,
                   contributor_from_id: this.idcontfinan,
                   contributor_to_id: this.idcontribuyente
      }
      if (this.hayBancos && this.selectedBank) {
        payment.bank = this.selectedBank; 
      }
      const params = {
        payment_source: 'PROVEEDOR',
        invoices: [],
        payment: payment
      };

      // tslint:disable-next-line: forin
      for (const prop in this.selectedFac) {
        params.invoices[prop] = {id: this.selectedFac[prop].id_factura.toString() };
      }
      swal2.fire({
        title: 'Procesando pago',
        text: 'Registrando la información...',
        allowOutsideClick: false
      });
      swal2.showLoading();
      let segundos = 0;
      this._guardarTimer = setInterval(() => {
        segundos++;
        const contenido = document.querySelector('.swal2-content') as HTMLElement;
        if (contenido) {
          if (segundos >= 45) {
            contenido.textContent = 'Seguimos procesando, por favor espere...';
          } else if (segundos >= 15) {
            contenido.textContent = 'Esto puede tardar un momento...';
          }
        }
      }, 1000);
      // Simula respuesta a los 80 segundos
      /*  setTimeout(() => {
          clearInterval(this._guardarTimer);
          swal2.close();
          swal2.fire('Simulación terminada', '', 'success');
        }, 80000);*/
      this._pagosservice.aplicarPagoRAWproveedor(params).subscribe( resp => {
        clearInterval(this._guardarTimer);

        // --- INICIO: Registro de trabajo para monitoreo de progreso ---
        // Se registra el pago en el servicio de polling antes del SweetAlert de éxito.
        // Esto persiste en sessionStorage para que al recargar la página se reconecte el polling.
        try {
          // Solo registrar job de polling si el procesamiento asíncrono está habilitado
          if (this.asyncPaymentProcessing) {
            // Obtener el nombre del proveedor/empresa seleccionado desde el DOM
            let nombreDestino = '';
            if (this.valorcsrecurso === 'SIN_RECURSO') {
              const selectProveedor: any = document.getElementById('proveedor');
              if (selectProveedor && selectProveedor.selectedIndex >= 0) {
                nombreDestino = selectProveedor.options[selectProveedor.selectedIndex].text || '';
              }
            } else if (this.valorcsrecurso === 'CON_RECURSO') {
              const selectProveedorw: any = document.getElementById('proveedorw');
              if (selectProveedorw && selectProveedorw.selectedIndex >= 0) {
                nombreDestino = selectProveedorw.options[selectProveedorw.selectedIndex].text || '';
              }
            }

            this.paymentPollingService.registerJob((resp as any).data.id, {
              numeroPago: (resp as any).data.attributes.payment_number || '',
              nombreDestino: nombreDestino,
              totalFacturas: this.selectedFac.length
            });
          }
        } catch (e) {
          // Ignorar silenciosamente - el pago ya se creó exitosamente en el backend
        }
        // --- FIN: Registro de trabajo para monitoreo de progreso ---

        swal2.close();
        swal2.fire({
          title: 'La información se registró',
          text: 'con éxito',
          icon: 'success',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {

          if ( res.value ) {
            window.location.reload();
          }

        } );

      }, (err) => {
        clearInterval(this._guardarTimer);
        swal2.close();
        console.log(err);
        swal2.fire({
          title: 'Ocurrio un error',
          text: err.error.errors[0],
          icon: 'error',
          showConfirmButton: true,
          showCancelButton: false,
          allowOutsideClick: false
        }). then ( res => {
          if ( res.value ) {
            this.ngOnInit();
          }
        } );
       } );

    }


  }

  // Detener polling al salir de la pantalla de pagos a proveedor
  ngOnDestroy(): void {
    this.paymentPollingService.destroy();
  }

}







